export const SET_EMPLOYEE_ID = 'EMPLOYEE_REGISTRATION/SET_EMPLOYEE_ID';
export const SET_EMPLOYEE = 'EMPLOYEE_REGISTRATION/SET_EMPLOYEE';
export const SET_RESTRICTIONS = 'EMPLOYEE_REGISTRATION/SET_RESTRICTIONS';
export const SET_EMPTY_EMPLOYEE = 'EMPLOYEE_REGISTRATION/SET_EMPTY_EMPLOYEE';
export const HANDLE_LOADING = 'EMPLOYEE_REGISTRATION/HANDLE_LOADING';
export const HANDLE_RESTRICTIONS_LOADING = 'EMPLOYEE_REGISTRATION/HANDLE_RESTRICTIONS_LOADING';